import { useParams } from 'react-router-dom'
import { ProfileFormPage } from '@/components/ProfileFormPage'

export const ProfileEditPage = () => {
  useParams<{ profileId: string }>()
  return <ProfileFormPage mode="edit" />
}
